import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import LoadingButton from '@mui/lab/LoadingButton';
import { Trans, useTranslation } from 'react-i18next';

type InstallAppModalType = {
    onCancel: () => void;
};

const InstallAppModal = (props: InstallAppModalType) => {
    const { onCancel } = props;
    const { t, i18n } = useTranslation();

    return (
        <Dialog
            fullWidth
            open
            onClose={(event, reason) => {
                if (reason !== 'backdropClick') {
                    onCancel();
                }
            }}
        >
            <DialogTitle>{t('MODAL_install_app_title')}</DialogTitle>
            <DialogContent>
                <p className="text-sm mb-4">{t('MODAL_install_app_message')}</p>

                {window?.Telegram?.WebApp?.platform === 'android' ? (
                    <a
                        href="https://play.google.com/store/apps/details?id=pro.calpal"
                        target="_blank"
                        className="p-3 flex items-center justify-center w-full"
                        rel="noreferrer"
                    >
                        <img src="/btn-get-google.png" alt="Google Play" className="w-1/2" />
                    </a>
                ) : (
                    <a
                        href="https://apps.apple.com/us/app/calpalpro/id6766320727"
                        target="_blank"
                        className="p-3 flex items-center justify-center w-full"
                        rel="noreferrer"
                    >
                        <img src="/btn-get-apple.png" alt="App Store" className="w-1/2" />
                    </a>
                )}
            </DialogContent>
            <DialogActions>
                <LoadingButton onClick={onCancel}>{t('MODAL_cancel')}</LoadingButton>
            </DialogActions>
        </Dialog>
    );
};

export default InstallAppModal;
